import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { fourPlaceHolder, getFormattedDate} from "modules/utilities/utility";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAllDoctorSlot } from "./store";
import { Button, Tabs } from "antd";
import _ from "lodash";
import { isEmpty } from "lodash";

function MedDoctorBookingSlot({ caseId }) {
  const {
    doctorSlotData,
    fetchAllDoctorSlot,
    isLoading,
    postDoctorSlotBooking,
    bookLoading
  } = useAllDoctorSlot();

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [slotMap, setSlotMap] = useState([]);
  const [slotBooked, setSlotBooked] = useState(null);

  const onSlotSelection = (slot) => {
    setSelectedSlot(slot);
  };

  useEffect(() => {
    if (_.size(doctorSlotData) > 0) {
      const slots = doctorSlotData
        .filter((slot) => new Date(slot.slotTime).getHours() < 19)
        .reduce((acc, slot) => {
          const formattedDate = moment(slot.slotTime).format("DD-MM-YYYY");
          if (!acc[formattedDate]) {
            acc[formattedDate] = [];
          }
          acc[formattedDate].push({
            slotLabel: moment(slot.slotTime).format("hh:mm A"),
            ...slot,
          });
          return acc;
        }, {});

      const slotsData = Object.entries(slots).map(([label, slots], index) => {
        const timeMap = slots?.map((slot) => {
          return selectedSlot?.slotTime === slot.slotTime ? (
            <Button className="m-1" type="primary">
              {slot?.slotLabel}
            </Button>
          ) : (
            <Button
              className="m-1"
              disabled={slot.slots.count === 0}
              onClick={() => {
                onSlotSelection(slot);
              }}
            >
              {slot?.slotLabel}
            </Button>
          );
        });

        return {
          label: label,
          key: index + 1,
          children: <>{timeMap?.map((time) => time)}</>,
        };
      });
      setSlotMap(slotsData);
    }
  }, [doctorSlotData, selectedSlot]);

  useEffect(() => {
    fetchAllDoctorSlot(caseId, toast);
  }, []);

  const handleClose = () => {
    setSelectedSlot(null);
  };

  const handleBookSlot = () => {
    if (selectedSlot) {
      const payload = {
        ...selectedSlot,
        slot_time: selectedSlot?.slotTime
      }
      postDoctorSlotBooking(caseId, payload, handleClose, toast, setSlotBooked);
    }
  };

  return (
   !isEmpty(slotBooked)?<div className="card p-3 font-poppins text-nowrap d-flex flex-row"><span>Doctor Slot booked at:</span> <span className="fw-bold text-danger ms-2">{getFormattedDate(slotBooked?.reminder_date)}</span></div> :<>
      <div className="border-bottom border-1 p-0 m-0">
        <>
          {isLoading? fourPlaceHolder():<Tabs
            defaultActiveKey="1"
            type="card"
            size={"middle"}
            items={slotMap}
          />}
        </>
        <Button className="mt-5 py-2 fs-1 w-100" type="primary" onClick={handleBookSlot}>
          {bookLoading ? (
            <span className="d-flex flex-row gap-2 justify-content-center">
              <Spinner animation="border" variant="light" />
              <span >Booking Call and Creating Ticket</span>
            </span>
          ) : (
            <span>
              <span>Booking Call and Create Ticket</span>
            </span>
          )}
        </Button>
      </div>
    </>
  );
}

export default MedDoctorBookingSlot;
